"use strict";

const TreatmentCtrl = function(PatientsService, $rootScope, FileSaver, Notification, $state){
  var ctrl = this;

  /**ctrl.addTreatment = function(){
      PatientsService.addTreatment(ctrl.patient.pid).then(function(data){
        ctrl.patient.treatments = data.data.treatments;
        Notification.success('Neue Behandlung wurde erfolgreich erstellt.');
        $state.go('main.patients.list.details.treatsteps',
          {
            treatId: ctrl.patient.treatments[ctrl.patient.treatments.length - 1].uuid, 
            treatment: ctrl.patient.treatments[ctrl.patient.treatments.length -1], 
            patient: ctrl.patient, 
            pid: ctrl.patient.pid
          });
      });
    };
    **/

    ctrl.finishTreatment = function(treatment){
      treatment.state = 'FINISHED';
      PatientsService.updateTreatment(treatment).then(function(data){
        treatment = data.data;
        Notification.success('Behandlung wurde erfolgreich abgeschlossen.');
      });
    };

    ctrl.getReport = function(uuid){
      PatientsService.getTreatmentReport(uuid).then(function(data){
        var file = new Blob([data.data], {type: 'application/pdf'});
        FileSaver.saveAs(file, "Behandlungsbericht-" + ctrl.patient.pid + ".pdf");
      }, function(){
        Notification.error("Die angeforderte Datei konnte nicht abgerufen werden.");
      });
    };

    ctrl.isFinishable = function(treatment) {
      if (treatment.state === 'FINISHED'){
        return false;
      }
      if (!$rootScope.user.hasPermission('10110')){
        return false;
      }
      if (treatment.actions.length === 0){
        treatment.finishMsg = "Keine Behandlungsschritte vorhanden.";
        return false;
      }
      for (var action in treatment.actions){
        if (!treatment.actions[action].valid){
          treatment.finishMsg = "Unvollständige Behandlungsschritte vorhanden.";
          return false;
        }
      }

      return true;
    };

  ctrl.requestDeletion = function(item){
    item.popover = false;
    PatientsService.addTreatmentDeletionRequest({
      'uuid': item.uuid,
      'comment': ctrl.deleteMsg
    }).then(
      function(){
        Notification.success('Ihr Löschantrag wurde erfolgreich eingereicht und wird nun von dem Datentreuhänder bearbeitet.');
        ctrl.deleteMsg = undefined;
      },
      function(error){
        if(error.status === 409){
          Notification.info('Es wurde bereits ein Löscheintrag für diese Behandlung eingereicht.');
        }else{
          Notification.error('Beim Einreichen des Löschantrags ist ein Fehler aufgetreten.');
        }
        ctrl.deleteMsg = undefined;
      });
  };
};

TreatmentCtrl.$inject = ['PatientsService', '$rootScope', 'FileSaver', 'Notification', '$state'];

module.exports = {
  bindings: {
    patient: '='
  },
  template: require('./treatments.html'),
  controller: TreatmentCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/patients/components/tile-treatments/treatments.component.js